import {mapActions, mapGetters} from 'vuex';

export default {
    computed: {
        ...mapGetters('mediaConversion', ['getConvertedImage', 'isConverted', 'isConverting'])
    },

    methods: {
        ...mapActions('mediaConversion', ['convertImage']),

        async getDisplayImageUrl(attachment) {
            if (!attachment || !attachment.link) return '';

            const isHeic = this.isHeicFormat(attachment.name);
            if (!isHeic) {
                return attachment.link;
            }

            const convertedUrl = this.getConvertedImage(attachment.link);
            if (convertedUrl) {
                return convertedUrl;
            }

            if (this.isConverting(attachment.link)) {
                return attachment.link;
            }

            try {
                const result = await this.convertImage({
                    originalUrl: attachment.link,
                    filename: attachment.name,
                });

                return result || attachment.link;
            } catch (error) {
                console.error('HEIC conversion failed:', error);
                return attachment.link;
            }
        },

        isHeicFormat(filename) {
            if (!filename) return false;
            const extension = filename.split('.').pop().toLowerCase();
            return extension === 'heic' || extension === 'heif';
        }
    }
};
